/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface SaveAPI
	 * @hideconstructor
	 * @classdesc API class that is used to save a dashboard.
	 * @example dashboard.getFeature('Save')
	 */
	class SaveAPI {
		/**
		* Updates an existing dashboard object.
		* @return {Promise<Object>} Resolved object contains the status of the save operation.
		*/
		save() { }


		/**
		 * Creates a new dashboard object.
		 * @async
		 * @param {name} name Dashboard name
		 * @param {url}  parentId Parent asset ID
		 * @param {boolean} overwrite Indicates whether the saveAs method can overwrite an existing dashboard; default is true.
		 * @return {Promise<Object>}  Resolved object contains the status of the saveAs operation.
		 */
		saveAs(){}
	}

	return SaveAPI;
});
